import React from 'react';
import {JsonScreenConsumer} from '../../ContextComponents/JsonScreenContext/'

const JsonScreenHoc = (Wrapped) => {
    return (props) => {
        return (
            <JsonScreenConsumer>
                {
                    (screenProps) => {
                        return (
                            <Wrapped {...screenProps} {...props} />
                        )
                    }
                }
            </JsonScreenConsumer>
        )
    }
};
export default JsonScreenHoc;